export const returns = {
  orderCancellation: {
    breadcrumb: {
      service: 'Service-Vorteile',
      cancellation: 'Retoure & Bestellungen Widerrufen',
      success: 'Bestätigung',
    },
    page: {
      title: 'Retoure oder Widerruf Deiner Bestellung',
      introText1:
        'Du kannst eine Retoure oder einen Widerruf für Deine Bestellung über das untenstehende Formular veranlassen. Diese Option steht sowohl registrierten Kunden als auch Gastbestellern zur Verfügung.',
    },
    form: {
      orderNumber: 'Auftragsnummer',
      orderNumberError: 'Bitte geben Sie Ihre Auftragsnummer ein.',
      customerNumber: 'Kundennummer',
      submit: 'BESTELLUNG ANZEIGEN',
    },
    cancelOrder: {
      title: 'Artikel widerrufen oder retournieren',
      introText2:
        'Wähle die Artikel aus, die Du widerrufen oder retournieren möchten, und bestätige Deine Anfrage unten. Einige Artikel sind von der Retoure ausgeschlossen, wie konfigurierte oder maßgefertigte Produkte.',
      orderHeading: 'Bestellung {{orderNumber}}',
      orderDate: 'Bestelldatum:',
      selectAll: 'Alle auswählen',
      columnArticle: 'Artikel',
      columnQuantity: 'Menge',
      columnUnitPrice: 'Einzelpreis',
      columnTotalPrice: 'Preis',
      confirmationLabel:
        'Ich bestätige, dass ich die ausgewählten Artikel aus dieser Bestellung retournieren möchte',
      contactNameLabel: 'Name des Ansprechpartners',
      contactEmailLabel: 'E-Mail Adresse des Ansprechpartners',
      contactEmailError: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      submitButton: 'Widerrufen oder Retournieren',
      submitHint:
        'Sobald du auf „Artikel widerrufen & Retournieren" klickst, senden wir dir eine E-Mail zur Bestätigung, dass die Anfrage eingegangen ist.',
      notFoundError:
        'Die angegebene Auftrags- oder Kundennummer wurde nicht gefunden. Bitte überprüfen Sie Ihre Angaben.',
      notCancellableTitle: 'Diese Bestellung ist vom Widerruf ausgeschlossen',
      notCancellableIntro:
        'Bestimmte Artikel, wie konfigurierte oder maßgefertigte Produkte, können nach Aufgabe der Bestellung nicht storniert werden. Bei Fragen melden Sie sich bitte beim Kundenservice.',
      notCancellableContactLink: 'Kundenservice kontaktieren',
      backToHome: 'Zurück zur Startseite',
    },
    productCard: {
      articleNumber: 'Artikelnummer: {{code}}',
      quantity: 'Menge',
      net: 'Netto',
      returnQuantityLabel: 'Menge',
      reasonLabel: 'Aus welchem Grund möchtest Du den Artikel retournieren? (optional)',
      descriptionLabel: 'Beschreibung',
      reason: {
        damageBefore: 'Schaden vor Gebrauch',
        damageAfter: 'Schaden nach Gebrauch',
        wrongItem: 'Falscher Artikel geliefert',
        wrongQuantity: 'Falsche Menge geliefert',
        return: 'Retoure innerhalb der Widerrufsfrist',
      },
      notCancellableText: 'Dieser Artikel ist vom Widerruf ausgeschlossen, da er individuell angefertigt wurde.',
      notCancellableContactPrefix: 'Falls du Fragen zu dieser Restriktion hast, melde dich bitte bei unserem ',
      notCancellableContactLink: 'Kundenservice',
    },
    success: {
      title: 'Danke. Wir haben Deine Anfrage erhalten.',
      backToHome: 'Zurück zu Startseite',
      returnSectionHeading: 'Artikel zurücksenden',
      returnSectionText:
        'Wenn Du Deine Artikel bereits erhalten hast, kannst Du unten ein Rücksendeetikett herunterladen. Wir übernehmen damit die Rücksendekosten.',
      dhlButton: 'DHL Retouren-Etikett drucken',
      postButton: 'Post Retouren-Etikett drucken',
      dropOffHeading: 'Eine Paketannahmestelle in Deiner Nähe findest Du',
      dropOffDhlPrefix: 'für DHL:',
      dropOffPostPrefix: 'für Post AT:',
    },
  },
  breadcrumb: {
    service: 'Service-Vorteile',
    returns: 'Retoure',
  },
  returns: {
    page: {
      title: 'Retouren bei HABA',
      introHeading: 'Wie sende ich einen Artikel zurück?',
      introText:
        'Bei HABA kauft ihr auf Probe, d. h. ihr könnt gelieferte Ware ohne Angabe von Gründen innerhalb von 4 Wochen nach Erhalt kostenfrei und risikolos zurückgeben.',
      stepsHeading: 'So einfach geht Zurücksenden bei HABA',
      steps: {
        originalPackaging:
          'Ganz praktisch in der Originalverpackung (sonst maximal 60 x 60 x 120 cm, höchstens 31,5 kg)',
        returnSlip:
          'Bitte legt den Retourenschein mit ausgefüllten Retourengründen ins Paket. Lasst uns wissen, was wir besser machen können!',
        label:
          'Klebt das HABA Retouren-Etikett gut sichtbar aufs Paket. Damit ist die Rücksendung für euch kostenlos!',
        receipt:
          'Bitte den Versand-Beleg gut aufheben, sollte das Paket doch einmal verloren gehen.',
      },
      noLabelHeading: 'Kein Retouren-Etikett zur Hand?',
    },
    form: {
      description:
        'Einfach hier ausdrucken. Gebe im nachfolgenden Eingabefeld einfach deine Auftragsnummer ein und klicke auf Abschicken.',
      orderNumberLabel: 'Auftragsnummer',
      orderNumberPlaceholder: 'Auftragsnummer',
      submit: 'Absenden',
      invalidOrder: 'Die angegebene Bestellnummer ist ungültig oder konnte nicht gefunden werden.',
      instructionsHeading: "Retouren-Etikett selbst erstellen - so einfach geht's:",
      instructions: {
        dhl: 'Retouren werden über DHL entgegengenommen.',
        onlineForm: 'Es öffnet sich das Online-Retouren-Formular.',
        enterData: 'Tragen Sie Ihre Daten ein.',
        receiveLabel:
          'Sie erhalten Ihr Retouren-Etikett per E-Mail und können es direkt ausdrucken. Oder einfach den QR-Code auf Ihrem Smartphone speichern und im Paketshop vorzeigen.',
      },
      dhlImageAlt: 'DHL Retoure',
      returnAT: 'Post Retourenschein',
    },
  },
};
